import React, {useEffect, useState} from 'react';
import {FilterIcon} from "../../icons/icons";
import Radio from "../UI/radio/radio";
import CustomButton from "../UI/customButton/customButton";
import {useTranslation} from "react-i18next";

const Filter = () => {
  const [ open , setOpen ] = useState(false)
  const {t} = useTranslation();


  return (
    <>
      <div onClick={() => setOpen(!open)} className={"bg-white border rounded-lg py-1 flex items-center justify-center"}>
        <FilterIcon/>
      </div>
      <div className={`${open ? "translate-y-0" : "translate-y-full"} duration-500 fixed w-full right-0 bottom-0 rounded-t-xl bg-white p-5 border-gray-300 border-[.12rem] border-b-0 z-[10000]`}>
         <span className={"h-1 w-20 bg-gray-400 m-auto flex mb-10"}/>
         <div className={"flex flex-col gap-3 mt-3"}>
           <Radio name={"filter"} label={"براساس نام (فارسی)"} id={1}/>
           <Radio name={"filter"} label={"براساس نام (انگلیسی)"} id={2}/>
           <Radio name={"filter"} label={"براساس جدیدترین"} id={3}/>
           <CustomButton title={t("apply")}/>
         </div>
      </div>
    </>
  );
};

export default Filter;
